module.exports = __webpack_public_path__ + "img/sh_logo.61c848cc.png";